<div class="account-policy">
  <div class="header">
    <h1 class="page-title">Account Policy</h1>
  </div>

  <div class="tabs">
    @for (tab of tabs; track tab.id) {
      <div class="tab" [class.tab-selected]="isTabSelected(tab.id)" (click)="onTabSelect(tab.id)">
        {{ tab.label }}
      </div>
    }
  </div>

  <div class="tab-content">
    @if (selectedTabId === 'global-configurations') {
      <app-global-configurations></app-global-configurations>
    }

    @if (selectedTabId === 'platforms') {
      <app-platforms-tab></app-platforms-tab>
    }
  </div>
</div>
